/* unplugin-vue-components disabled */import { render } from "./tagNav.vue?vue&type=template&id=23cd70ea&scoped=true&ts=true"
import script from "./tagNav.vue?vue&type=script&lang=ts"
export * from "./tagNav.vue?vue&type=script&lang=ts"

import "./tagNav.vue?vue&type=style&index=0&id=23cd70ea&scoped=true&lang=css"

import exportComponent from "E:\\Workspaces\\VScode\\vue3+TS\\vue案例\\cloudMusicProject-master\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23cd70ea"],['__file',"src/views/latestMusic/cpns/tagNav.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "23cd70ea"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('23cd70ea', __exports__)) {
    console.log('reload')
    api.reload('23cd70ea', __exports__)
  }
  
  module.hot.accept("./tagNav.vue?vue&type=template&id=23cd70ea&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('23cd70ea', render)
  })

}


export default __exports__